import { defineMessages } from '@/components/formatted_message/FormattedMessage';
import {
  ElectricityHighVoltageCategory,
  ElectricityLowVoltageCategory,
  GasCategory,
  OtherCategory,
  SUPPLY_POINT_GENERATOR_CATEGORY,
  ThermalCategory,
  WaterCategory,
  type SupplyPointCategoryType,
} from '@enmon/commons/lib/enmon';

export const SUPPLY_POINT_CATEGORY_TRANSLATED = defineMessages<SupplyPointCategoryType>({
  [ElectricityHighVoltageCategory.VeryHighVoltage]: {
    id: 'app.common.supplyPoint.supplyPointCategory.veryHighVoltage',
  },
  [ElectricityHighVoltageCategory.HighVoltage]: {
    id: 'app.common.supplyPoint.supplyPointCategory.highVoltage',
  },
  [ElectricityLowVoltageCategory.LowVoltage]: {
    id: 'app.common.supplyPoint.supplyPointCategory.lowVoltage',
  },
  [SUPPLY_POINT_GENERATOR_CATEGORY]: {
    id: 'app.common.supplyPoint.supplyPointCategory.generator',
  },
  [GasCategory.SmallScale]: {
    id: 'app.common.supplyPoint.supplyPointCategory.gasSmallScale',
  },
  [GasCategory.MediumScale]: {
    id: 'app.common.supplyPoint.supplyPointCategory.gasMediumScale',
  },
  [GasCategory.LargeScale]: {
    id: 'app.common.supplyPoint.supplyPointCategory.gasLargeScale',
  },
  [WaterCategory.Mains]: {
    id: 'app.common.supplyPoint.supplyPointCategory.mains',
  },
  [WaterCategory.Sewage]: {
    id: 'app.common.supplyPoint.supplyPointCategory.sewage',
  },
  [WaterCategory.MainsSewage]: {
    id: 'app.common.supplyPoint.supplyPointCategory.mainsSewage',
  },
  [WaterCategory.Rainwater]: {
    id: 'app.common.supplyPoint.supplyPointCategory.rainwater',
  },
  [ThermalCategory.Heat]: {
    id: 'app.common.supplyPoint.supplyPointCategory.heat',
  },
  [ThermalCategory.Cold]: {
    id: 'app.common.supplyPoint.supplyPointCategory.cold',
  },
  [ThermalCategory.Combined]: {
    id: 'app.common.supplyPoint.supplyPointCategory.combined',
  },
  [OtherCategory.Fuels]: {
    id: 'app.common.supplyPoint.supplyPointCategory.fuels',
  },
  [OtherCategory.TechGases]: {
    id: 'app.common.supplyPoint.supplyPointCategory.techGases',
  },
  [OtherCategory.Waste]: {
    id: 'app.common.supplyPoint.supplyPointCategory.waste',
  },
  [OtherCategory.Services]: {
    id: 'app.common.supplyPoint.supplyPointCategory.services',
  },
});
